import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=0576f904&scoped=true&"
import script from "./plan.vue?vue&type=script&lang=js&"
export * from "./plan.vue?vue&type=script&lang=js&"
import style0 from "./plan.vue?vue&type=style&index=0&id=0576f904&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0576f904",
  null
  
)

export default component.exports